<endoo-times-control [times]="timesControlData" (onChange)="timeSettingsChanged($event)"></endoo-times-control>
<mat-divider></mat-divider>
<div class="button-margin-top">
    <button mat-raised-button color="primary" (click)="saveWifiTimeSettings()" [disabled]="background_working">
        Speichern</button>
</div>